import { render, staticRenderFns } from "./SessionDetailModal.vue?vue&type=template&id=a4d99b92&scoped=true"
import script from "./SessionDetailModal.vue?vue&type=script&lang=js"
export * from "./SessionDetailModal.vue?vue&type=script&lang=js"
import style0 from "./SessionDetailModal.vue?vue&type=style&index=0&id=a4d99b92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d99b92",
  null
  
)

export default component.exports